import axios from "axios";
import HxfAppServersService from "../services/hxfAppServersService";
import BarrelWrapper from "./barrelWrapper";
function warehousesController() {
  const getWarehousesListJson = (extraOptions: any = null) => {
    let orderByQuery = "";
    let url = HxfAppServersService().getBackend() + "warehouses/listJson/?";
    if (extraOptions !== null) {
      let optionKeys = Object.keys(extraOptions);
      let addedFirst = false;
      for (let i = 0; i < optionKeys.length; i++) {
        let key = optionKeys[i];
        let value = extraOptions[key];
        if (value !== "") {
          if (!addedFirst) {
            addedFirst = true;
          } else {
            url = url + "&";
          }
          url = url + key + "=" + value;
        }
      }
    }

    return BarrelWrapper().appPostRequest(url, {});
  };

  return { getWarehousesListJson };
}

export default warehousesController;
